// Digit utilities — convert between Arabic-Indic/Persian digits and ASCII,
// and localize displayed numbers based on the user's chosen digit style.

// Arabic-Indic (U+0660–U+0669) and Persian (U+06F0–U+06F9) → ASCII (0–9).
const AR_TO_EN = {
  "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4",
  "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9",
  "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4",
  "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9",
};

const EN_TO_AR = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];

// Normalize any input string so parseFloat / parseInt can handle it,
// regardless of whether the user typed Arabic, Persian or ASCII digits.
// Also accepts the Arabic decimal separator ٫ and thousands separator ٬.
export const normalizeDigits = (input) => {
  if (input === null || input === undefined) return "";
  const s = String(input);
  let out = "";
  for (const ch of s) {
    if (AR_TO_EN[ch]) out += AR_TO_EN[ch];
    else if (ch === "٫") out += ".";
    else if (ch === "٬" || ch === "،") out += ",";
    else out += ch;
  }
  return out;
};

// Convert ASCII digit characters inside a string to Arabic-Indic digits.
// Non-digit characters (currency symbols, commas, dots, letters) pass through.
export const toArabicIndicDigits = (input) => {
  if (input === null || input === undefined) return "";
  const s = String(input);
  let out = "";
  for (const ch of s) {
    const code = ch.charCodeAt(0);
    if (code >= 48 && code <= 57) out += EN_TO_AR[code - 48];
    else out += ch;
  }
  return out;
};

// Convenience: localize a formatted number string based on the digit mode.
//   digitsMode === "ar" → Arabic-Indic digits
//   anything else       → ASCII digits (unchanged)
export const localizeDigits = (str, digitsMode) =>
  digitsMode === "ar" ? toArabicIndicDigits(str) : String(str ?? "");
